<div class="chat-container" [class.expanded]="isOpen()" [class.full-height]="isFullHeight()" [class.full-page]="isFullPage" (click)="onContainerClick()" (mousedown)="preserveInputFocus($event)">
  @if (isOpen()) {
    @if (!(isFullPage && windowService.isDesktopRes)) {
      <div class="chat-header">
        <div class="chat-top-bar">
          @if (isRentalClient() && !isDocked && !isFullPage) {
            <span class="setup-call-link" (click)="openScheduleCallModal(); $event.stopPropagation()">Free Setup Call</span>
          }
          @if (!isDocked && !isFullPage && canDock() && windowService.isDesktopRes) {
            <button class="dock-button" (click)="dockToSiderail(); $event.stopPropagation()" title="Dock to side">
              <span class="material-icons">vertical_split</span>
            </button>
          }
          @if (!isDocked && !isFullPage) {
            <button class="close-button" (click)="closeChat($event)">
              <img src="assets/img/minus.svg" class="minus-icon" />
            </button>
          }
        </div>
        <tidy-header-select
          class="chat-session-select"
          [items]="sessionSelectItems()"
          [selectedValue]="currentSessionId()?.toString() ?? ''"
          [richItems]="true"
          [showItemActions]="true"
          [editable]="true"
          [isEditing]="editingSubject()"
          [editingValue]="editingSubjectValue()"
          [placeholder]="'New Chat'"
          (optionChange)="onSessionSelected($event)"
          (editItem)="onEditSessionItem($event)"
          (deleteItem)="onDeleteSessionItem($event)"
          (editingValueChange)="editingSubjectValue.set($event)"
          (editSave)="saveSubject()"
          (editCancel)="cancelEditingSubject()" />
        @if (!isCreatingNewChat()) {
          <tidy-small-button
            [iconOnly]="!windowService.isDesktopRes || isDocked"
            [text]="windowService.isDesktopRes && !isDocked ? 'New Chat' : ''"
            [image]="addButtonIconUri"
            (buttonClick)="newChat()" />
        }
        @if (isManualRefreshing()) {
          <ion-spinner name="lines" class="chat-refresh-spinner" />
        }
        @if (isDocked && windowService.isDesktopRes) {
          <button class="undock-button" (click)="undockFromSiderail(); $event.stopPropagation()" title="Undock">
            <img src="assets/img/minus.svg" class="minus-icon" />
          </button>
        }
        @if ((isLoadingSession() || isLoading()) && localMessages().length === 0) {
          <div class="header-loading-container">
            <div class="header-loading-bar"></div>
          </div>
        }
      </div>
    }

    <div class="messages-wrapper">
      @if (isVoiceMode() && voiceConnectionStatus() === 'connected') {
        <div class="voice-orb-container">
          <div class="voice-orb" #voiceOrb></div>
        </div>
      }

      <div class="messages-container" #scrollContainer>
        @if (isLoadingMoreMessages()) {
          <div class="load-more-loading-container">
            <div class="load-more-loading-bar"></div>
          </div>
        }
        @if (isCreatingNewChat() && messages().length === 0 && !isVoiceMode()) {
          <div class="suggestions-header">How can we help?</div>
          <div class="suggestion-pills-wrapper">
            <div
              class="suggestion-pills-row top-row"
              [class.paused]="isPillAnimationPaused()"
              (mouseenter)="pausePillAnimation()"
              (mouseleave)="resumePillAnimation()"
              (touchstart)="pausePillAnimation()"
              (touchend)="resumePillAnimation()">
              <div class="pills-track">
                @for (suggestion of topRowSuggestions(); track suggestion.id) {
                  <button class="suggestion-pill" (click)="onSuggestionClick(suggestion)">
                    <span class="material-icons pill-icon">{{ suggestion.icon }}</span>
                    <span class="pill-text">{{ suggestion.displayText }}</span>
                    <span class="pill-time">&middot; {{ suggestion.timeAgo }}</span>
                  </button>
                }
                @for (suggestion of topRowSuggestions(); track suggestion.id) {
                  <button class="suggestion-pill" (click)="onSuggestionClick(suggestion)">
                    <span class="material-icons pill-icon">{{ suggestion.icon }}</span>
                    <span class="pill-text">{{ suggestion.displayText }}</span>
                    <span class="pill-time">&middot; {{ suggestion.timeAgo }}</span>
                  </button>
                }
              </div>
            </div>
            <div
              class="suggestion-pills-row middle-row"
              [class.paused]="isPillAnimationPaused()"
              (mouseenter)="pausePillAnimation()"
              (mouseleave)="resumePillAnimation()"
              (touchstart)="pausePillAnimation()"
              (touchend)="resumePillAnimation()">
              <div class="pills-track">
                @for (suggestion of middleRowSuggestions(); track suggestion.id) {
                  <button class="suggestion-pill" (click)="onSuggestionClick(suggestion)">
                    <span class="material-icons pill-icon">{{ suggestion.icon }}</span>
                    <span class="pill-text">{{ suggestion.displayText }}</span>
                    <span class="pill-time">&middot; {{ suggestion.timeAgo }}</span>
                  </button>
                }
                @for (suggestion of middleRowSuggestions(); track suggestion.id) {
                  <button class="suggestion-pill" (click)="onSuggestionClick(suggestion)">
                    <span class="material-icons pill-icon">{{ suggestion.icon }}</span>
                    <span class="pill-text">{{ suggestion.displayText }}</span>
                    <span class="pill-time">&middot; {{ suggestion.timeAgo }}</span>
                  </button>
                }
              </div>
            </div>
            <div
              class="suggestion-pills-row bottom-row"
              [class.paused]="isPillAnimationPaused()"
              (mouseenter)="pausePillAnimation()"
              (mouseleave)="resumePillAnimation()"
              (touchstart)="pausePillAnimation()"
              (touchend)="resumePillAnimation()">
              <div class="pills-track">
                @for (suggestion of bottomRowSuggestions(); track suggestion.id) {
                  <button class="suggestion-pill" (click)="onSuggestionClick(suggestion)">
                    <span class="material-icons pill-icon">{{ suggestion.icon }}</span>
                    <span class="pill-text">{{ suggestion.displayText }}</span>
                    <span class="pill-time">&middot; {{ suggestion.timeAgo }}</span>
                  </button>
                }
                @for (suggestion of bottomRowSuggestions(); track suggestion.id) {
                  <button class="suggestion-pill" (click)="onSuggestionClick(suggestion)">
                    <span class="material-icons pill-icon">{{ suggestion.icon }}</span>
                    <span class="pill-text">{{ suggestion.displayText }}</span>
                    <span class="pill-time">&middot; {{ suggestion.timeAgo }}</span>
                  </button>
                }
              </div>
            </div>
          </div>
        }
        @for (message of messages(); track trackByMessageId($index, message); let i = $index) {
          @if (shouldShowTimeIndicator(i) && message.timestamp) {
            <div class="time-indicator">{{ message.timestamp | messageTime }}</div>
          }
          <div class="chat-message" [class.user]="message.role === 'user'" [class.other]="message.role === 'ai'" [class.last-in-group]="isLastInGroup(i)">
            @if (message.role === 'ai' && isLastInGroup(i)) {
              <div class="message-avatar-initials">
                @if (!message.userType || message.userType === 'AiTask' || message.userType === 'AiFrontendAgent') {
                  <tidy-ai-loader class="chat-avatar-loader" />
                } @else {
                  <tidy-initials-icon [fullName]="message.senderName || 'TIDY'" />
                }
              </div>
            }
            <div class="message-content-col">
              <div class="message-bubble">
                @if (message.content && message.content !== 'Attachment') {
                  <div class="message-text" [innerHTML]="message.content | linkify | enrichLinks:sharedLinkCache()"></div>
                  @if (message.role !== 'user' && isDisputeThread() && (message.content.includes('counterproposed') || message.content.includes('dispute'))) {
                    <div class="dispute-notice">
                      <div class="dispute-notice-icon">⚠️</div>
                      <div class="dispute-notice-content">
                        @if (message.content.includes('counterproposed')) {
                          <span class="dispute-notice-title">Action Required</span>
                          <span class="dispute-notice-text">Review and respond to this counter-proposal</span>
                        } @else if (message.content.includes('resolved')) {
                          <span class="dispute-notice-title">Dispute Resolved</span>
                          <span class="dispute-notice-text">This dispute has been resolved</span>
                        } @else {
                          <span class="dispute-notice-title">Dispute Opened</span>
                          <span class="dispute-notice-text">A dispute has been opened for this job</span>
                        }
                      </div>
                      <button class="dispute-notice-btn" (click)="goToDisputeResolution()">Go to Job Page</button>
                    </div>
                  }
                }
                @if ((message.content | extractPaymentLinkUuid:sharedLinkCache()); as paymentUuid) {
                  <inline-payment-form
                    [uuid]="paymentUuid"
                    [sharedLink]="sharedLinkCache().get(paymentUuid)!"
                    (paymentSuccess)="onInlinePaymentSuccess()" />
                }
                @if (message.attachments && message.attachments.length > 0) {
                  <div class="message-attachments">
                    <attachment-carousel
                      [files]="message.attachments"
                      [downloadAction]="downloadFile" />
                  </div>
                }
              </div>
              @if (message.isFeedbackEligible) {
                <div class="message-feedback">
                  <button
                    class="feedback-btn"
                    [class.active]="getMessageFeedback(message.id) === 'positive'"
                    (click)="onThumbClick(message, 'positive'); $event.stopPropagation()">
                    <img [src]="getMessageFeedback(message.id) === 'positive' ? 'assets/svg/thumbs-up.svg' : 'assets/svg/thumbs-up-outline.svg'" />
                  </button>
                  <button
                    class="feedback-btn"
                    [class.active]="getMessageFeedback(message.id) === 'negative'"
                    (click)="onThumbClick(message, 'negative'); $event.stopPropagation()">
                    <img [src]="getMessageFeedback(message.id) === 'negative' ? 'assets/svg/thumbs-down.svg' : 'assets/svg/thumbs-down-outline.svg'" />
                  </button>
                </div>
                @if (activeFeedbackMessageId() === message.id) {
                  <div class="feedback-form" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                    <div class="feedback-form-header">
                      {{ activeFeedbackType() === 'positive' ? 'What did you like?' : 'What could be improved?' }}
                    </div>
                    <textarea
                      class="feedback-textarea"
                      [placeholder]="activeFeedbackType() === 'positive' ? ('Tell us what was helpful...' | translate) : ('Tell us how we can do better...' | translate)"
                      #feedbackInput
                      (keydown.enter)="$event.preventDefault(); submitFeedback(message)"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"></textarea>
                    <div class="feedback-form-actions">
                      <button class="feedback-cancel-btn" (click)="cancelFeedback(); $event.stopPropagation()">Cancel</button>
                      <button class="feedback-submit-btn" [disabled]="isSubmittingFeedback()" (click)="submitFeedback(message); $event.stopPropagation()">
                        @if (isSubmittingFeedback()) {
                          Sending...
                        } @else {
                          Submit
                        }
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
        @if ((isTyping() || showPendingIndicator()) && !isEscalated()) {
          <div class="chat-message other last-in-group thinking-message-wrapper">
            <div class="message-avatar-initials">
              <tidy-ai-loader class="chat-avatar-loader" />
            </div>
            <div class="message-content-col">
              <div class="message-bubble typing-bubble">
                <span class="ascii-spinner">{{ spinnerFrame() }}</span>
              </div>
            </div>
          </div>
        }
        @if (isEscalated() && !isCreatingNewChat()) {
          <div class="time-indicator">Request escalated (estimated response &lt; 2 hours)</div>
        }
    </div>
    </div>

  }

  @if (isVoiceMode()) {
    <div class="voice-inline-controls">
      @if (isVideoOn()) {
        <div class="voice-pip-video">
          <video #voiceVideoElement autoplay playsinline muted class="pip-video-feed"></video>
        </div>
      }
      <div class="voice-status-row">
        @if (isGeminiReconnecting()) {
          <span class="voice-status-text connecting">Reconnecting...</span>
        } @else if (voiceConnectionStatus() === 'connecting') {
          <span class="voice-status-text connecting">Connecting...</span>
        } @else if (voiceConnectionStatus() === 'connected') {
          <div class="voice-status-connected">
            <div class="sound-bars" #soundBarsContainer>
              @for (bar of barIndices; track bar) {
                <div class="sound-bar"></div>
              }
            </div>
            @if (awaitingFirstUserSpeech() && !liveTranscript()) {
              <span class="voice-status-text">Start talking</span>
            }
          </div>
        }
      </div>
      <div class="voice-action-buttons">
        <!-- <button class="voice-inline-btn" [class.active]="isVideoOn()" (click)="handleVideoClick()" title="Video">
          <ion-icon name="videocam-outline"></ion-icon>
        </button> -->
        <button class="voice-inline-btn" [class.active]="isAudioMuted()" (click)="toggleAudioMute()" title="Mute speaker">
          <ion-icon [name]="isAudioMuted() ? 'volume-mute-outline' : 'volume-high-outline'" />
        </button>
        <button class="voice-inline-btn" [class.active]="isMuted()" (click)="toggleMute()" title="Mute">
          <ion-icon [name]="isMuted() ? 'mic-off-outline' : 'mic-outline'" />
        </button>
      </div>
    </div>
  }

  <div class="input-area" (click)="$event.stopPropagation()">
    @if (autoSuggestResults().length > 0) {
      <div class="autosuggest-dropdown">
        @for (suggestion of autoSuggestResults(); track suggestion.text; let idx = $index) {
          <button
            class="autosuggest-item"
            [class.highlighted]="highlightedSuggestIndex() === idx"
            (mousedown)="onAutoSuggestSelect(suggestion); $event.preventDefault()">
            <span class="material-icons autosuggest-icon">{{ suggestion.icon }}</span>
            <span class="autosuggest-text">{{ suggestion.displayText || suggestion.text }}</span>
          </button>
        }
      </div>
    }
    @if (!isFullPage && !isOpen() && messages().length > 0) {
      <div class="collapsed-preview" (click)="openChat()">
        <tidy-initials-icon class="small" [class.user-initials]="!showPendingIndicator() && messages()[messages().length - 1]?.role === 'user'" [fullName]="showPendingIndicator() ? 'TIDY' : (messages()[messages().length - 1]?.senderName || 'TIDY')" />
        @if (showPendingIndicator() && !isEscalated()) {
          <span class="ascii-spinner collapsed">{{ spinnerFrame() }}</span>
        } @else {
          <span class="preview-text">{{ collapsedPreview() }}</span>
        }
      </div>
    }
    @if (pendingAttachments().length > 0) {
      <div class="pending-attachments-container">
        @for (attachment of pendingAttachments(); track attachment.url; let i = $index) {
          <div class="pending-attachment">
            @if (attachment.isImage) {
              <img [src]="attachment.url" class="attachment-thumbnail" />
            } @else {
              <div class="attachment-file-card">
                <img src="assets/svg/document-outline.svg" class="attachment-file-icon" />
                <span class="attachment-file-name">{{ attachment.filename }}</span>
              </div>
            }
            <button class="remove-attachment-btn" (click)="removeAttachment(i)">
              <span class="material-icons">close</span>
            </button>
          </div>
        }
      </div>
    }
    <form [formGroup]="chatForm" novalidate action="#" (click)="!isOpen() && openChat()" (keydown)="onFormKeyDown($event)">
      <tidy-message-input
        #chatMessageInput
        formControlName="message"
        [placeholder]="placeholderText"
        [speakMode]="true"
        [isVoiceActive]="isVoiceMode()"
        [rightIconAction]="boundSendMessage"
        [leftIconAction]="boundAddAttachment"
        [leftIcon]="attachIconUri"
        [isSendingMessage]="isSending()"
        [hasAttachment]="pendingAttachments().length > 0"
        [showLoadingOverlay]="false"
        (speakClick)="handleSpeakClick()" />
    </form>
  </div>
</div>

@if (isPasswordOverlayVisible()) {
  <div class="password-overlay" [formGroup]="passwordForm">
    <div class="password-card">
      <tidy-text [title]="'Set Your Password'" />
      <tidy-input
        [label]="'New Password'"
        [type]="'password'"
        formControlName="password"
        [form]="passwordForm.controls.password" />
      <tidy-input
        [label]="'Confirm Password'"
        [type]="'password'"
        formControlName="confirmPassword"
        [form]="passwordForm.controls.confirmPassword" />
      @if (passwordError()) {
        <tidy-error-message [text]="passwordError()" />
      }
      <tidy-row>
        <tidy-button
          [text]="'Cancel'"
          [action]="cancelPasswordOverlay.bind(this)"
          class="secondary" />
        <tidy-button
          [text]="'Set Password'"
          [action]="submitPassword.bind(this)"
          class="primary" />
      </tidy-row>
    </div>
  </div>
}
@for (asset of pendingAssets(); track asset.id) {
  <div [class]="'asset-card asset-corner-' + asset.corner">
    @if (asset.iconUrl) {
      <img [src]="asset.iconUrl" class="asset-card-icon" alt="" />
    }
    <div class="asset-card-info">
      <span class="asset-card-name">{{ asset.categoryName }}</span>
      <span class="asset-card-address">{{ asset.addressName }}</span>
    </div>
    <div class="asset-card-actions">
      <button class="asset-btn asset-btn-confirm" (click)="confirmAddAsset(asset)">Add</button>
      <button class="asset-btn asset-btn-wrong" (click)="rejectAddAsset(asset)">Wrong</button>
      <button class="asset-btn asset-btn-cancel" (click)="cancelAddAsset(asset)">Skip</button>
    </div>
  </div>
}
